import { render, staticRenderFns } from "./AnalyticsDetailRow.vue?vue&type=template&id=83b2f2a0&scoped=true"
import script from "./AnalyticsDetailRow.vue?vue&type=script&lang=js"
export * from "./AnalyticsDetailRow.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsDetailRow.vue?vue&type=style&index=0&id=83b2f2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b2f2a0",
  null
  
)

export default component.exports